__turbopack_context__.v({
  "addBtn": "ProspectStrategy-module__ZDyE_q__addBtn",
  "badges": "ProspectStrategy-module__ZDyE_q__badges",
  "card": "ProspectStrategy-module__ZDyE_q__card",
  "categories": "ProspectStrategy-module__ZDyE_q__categories",
  "categoriesComfort": "ProspectStrategy-module__ZDyE_q__categoriesComfort",
  "categoriesDense": "ProspectStrategy-module__ZDyE_q__categoriesDense",
  "categoriesFull": "ProspectStrategy-module__ZDyE_q__categoriesFull",
  "category": "ProspectStrategy-module__ZDyE_q__category",
  "categoryLabel": "ProspectStrategy-module__ZDyE_q__categoryLabel",
  "chevron": "ProspectStrategy-module__ZDyE_q__chevron",
  "chip": "ProspectStrategy-module__ZDyE_q__chip",
  "chipEdit": "ProspectStrategy-module__ZDyE_q__chipEdit",
  "chipEditText": "ProspectStrategy-module__ZDyE_q__chipEditText",
  "collapseBottom": "ProspectStrategy-module__ZDyE_q__collapseBottom",
  "collapseBtn": "ProspectStrategy-module__ZDyE_q__collapseBtn",
  "description": "ProspectStrategy-module__ZDyE_q__description",
  "favicon": "ProspectStrategy-module__ZDyE_q__favicon",
  "generate": "ProspectStrategy-module__ZDyE_q__generate",
  "generating": "ProspectStrategy-module__ZDyE_q__generating",
  "generatingText": "ProspectStrategy-module__ZDyE_q__generatingText",
  "group": "ProspectStrategy-module__ZDyE_q__group",
  "header": "ProspectStrategy-module__ZDyE_q__header",
  "headerLeft": "ProspectStrategy-module__ZDyE_q__headerLeft",
  "iconWrapper": "ProspectStrategy-module__ZDyE_q__iconWrapper",
  "itemDelete": "ProspectStrategy-module__ZDyE_q__itemDelete",
  "link": "ProspectStrategy-module__ZDyE_q__link",
  "linkEdit": "ProspectStrategy-module__ZDyE_q__linkEdit",
  "linkEditText": "ProspectStrategy-module__ZDyE_q__linkEditText",
  "linkEditTextDisplay": "ProspectStrategy-module__ZDyE_q__linkEditTextDisplay",
  "linkText": "ProspectStrategy-module__ZDyE_q__linkText",
  "links": "ProspectStrategy-module__ZDyE_q__links",
  "list": "ProspectStrategy-module__ZDyE_q__list",
  "listItem": "ProspectStrategy-module__ZDyE_q__listItem",
  "loading": "ProspectStrategy-module__ZDyE_q__loading",
  "placeholder": "ProspectStrategy-module__ZDyE_q__placeholder",
  "placeholderRow": "ProspectStrategy-module__ZDyE_q__placeholderRow",
  "tabs": "ProspectStrategy-module__ZDyE_q__tabs",
  "title": "ProspectStrategy-module__ZDyE_q__title",
  "updateAgo": "ProspectStrategy-module__ZDyE_q__updateAgo",
  "updateBanner": "ProspectStrategy-module__ZDyE_q__updateBanner",
  "updateText": "ProspectStrategy-module__ZDyE_q__updateText",
});
